module.exports = __webpack_public_path__ + "static/media/SA.9a2f192d.png";